import { injectable } from 'inversify';
import { store } from '../../store';
import { regionThunk } from './region.thunk';
import {
  useRegionSelector,
  setShowDialog,
  useShowDialogSelector,
} from './region.slice';
import { RegionType } from './region.enum';
import { Region } from './region.interface';
import { regionConfig } from '../../regionConfig';
/*
  sitRegion -> the app region that we browse. ex. https://conneqt.hitiq.com.au then we are browsing the au.
  localRegion -> User current region

*/

@injectable()
export class RegionService {
  useRegionSelector = useRegionSelector;
  useShowDialogSelector = useShowDialogSelector;
  dispatchRegion() {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    store
      .dispatch(regionThunk())
      .unwrap()
      .then((text) => {});
  }

  dispatchDialog(value: boolean) {
    store.dispatch(setShowDialog(value));
  }

  supportedLocalRegions(): Region[] {
    return [RegionType.US, RegionType.AU];
  }

  siteRegion() {
    const siteRegion: Region = regionConfig.region;
    return siteRegion;
  }

  localRegion(region: string) {
    const localRegion = RegionType[region as keyof typeof RegionType];
    return localRegion || region;
  }

  isRegionMatching(localRegion: string) {
    const siteRegion = regionConfig.region;
    return siteRegion?.toLowerCase() === localRegion?.toLowerCase();
  }
}
